require('./Foundation/HTML/HTML.js')
require('./Foundation/HTML/Beautifier.js')

window["Foundation"]["HTML"]["Parser"] = require('@desertnet/html-parser')
